import { render, staticRenderFns } from "./chargeslist.vue?vue&type=template&id=3d51dc85&scoped=true&"
import script from "./chargeslist.vue?vue&type=script&lang=js&"
export * from "./chargeslist.vue?vue&type=script&lang=js&"
import style0 from "./chargeslist.vue?vue&type=style&index=0&id=3d51dc85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d51dc85",
  null
  
)

export default component.exports